// These are server acknowledgments, never evidence of provider delivery.
export const oneoffCampaignSaveFeedback = (payload, send = false) => {
  if (!send) return {
    state: "saved",
    campaignId: payload?.id || null,
    message: "One off campaign saved successfully.",
  };
  const messages = {
    queued: "Campaign queued for sending. Delivery has not completed yet.",
    sending: "Campaign sending is in progress. Check the campaign status for delivery results.",
    processed: "Campaign processing has completed. Check the campaign status for delivery results.",
  };
  const state = payload?.send_status;
  return {
    state: messages[state] ? state : "unconfirmed",
    campaignId: payload?.id || payload?.campaign_id || null,
    message: messages[state] || (payload?.payment_status === "verified"
      ? "Payment verified, but sending needs review. Do not pay again. Check the campaign status or contact support."
      : "Campaign saved, but queueing was not confirmed. Check its status before retrying; do not create a duplicate campaign."),
  };
};
